import { ExpressionSpecification, LayerSpecification } from "mapbox-gl";

import GaiaMapStyle from "~/modules/map/components/GaiaMapStyle";
import { MAP_LEGEND_ICON_SIZE } from "~/modules/project/screens/ProjectDeliverablesScreen/components/ProjectDeliverablesMapLegend";

import { LAYER_DEFAULTS } from "./layerDefaults";

const DEFAULT_AREA_FILL_COLOR = "#07AFF8";
const DEFAULT_AREA_FILL_OPACITY = 0.1;
const DEFAULT_AREA_LINE_WIDTH = 3;
const DEFAULT_AREA_LINE_OPACITY = 0.5;

type Props = {
    id: string;
    source: string;
    color?: ExpressionSpecification | string;
    fillOpacity?: number;
    lineWidth?: number;
    lineOpacity?: number;
    filter?: ExpressionSpecification;
};

export function GaiaMapStylePlannerArea({ id, source, color, fillOpacity, lineWidth, lineOpacity, filter }: Props) {
    const layers: LayerSpecification[] = [
        {
            id: `${id}_fill`,
            source,
            type: "fill",
            slot: LAYER_DEFAULTS.slot,
            filter: withGeometryTypeFilter(filter, "Polygon"),
            paint: {
                "fill-color": color ?? DEFAULT_AREA_FILL_COLOR,
                "fill-opacity": fillOpacity ?? DEFAULT_AREA_FILL_OPACITY,
            },
        },
        {
            id: `${id}_outline`,
            source,
            type: "line",
            slot: LAYER_DEFAULTS.slot,
            filter: withGeometryTypeFilter(filter, "Polygon"),
            paint: {
                "line-color": color ?? DEFAULT_AREA_FILL_COLOR,
                "line-width": lineWidth ?? DEFAULT_AREA_LINE_WIDTH,
                "line-opacity": lineOpacity ?? DEFAULT_AREA_LINE_OPACITY,
            },
        },
        {
            id: `${id}_line`,
            source,
            type: "line",
            slot: LAYER_DEFAULTS.slot,
            filter: withGeometryTypeFilter(filter, "LineString"),
            paint: {
                "line-color": color ?? DEFAULT_AREA_FILL_COLOR,
                "line-width": lineWidth ?? DEFAULT_AREA_LINE_WIDTH,
                "line-opacity": lineOpacity ?? DEFAULT_AREA_LINE_OPACITY,
            },
        },
    ];

    return <GaiaMapStyle layers={layers} />;
}

export function GaiaMapStyleAreaFillSolidLegendIcon() {
    return (
        <svg width={MAP_LEGEND_ICON_SIZE} height={MAP_LEGEND_ICON_SIZE} viewBox="0 0 16 16" aria-hidden="true">
            <rect
                x={1}
                y={1}
                width={14}
                height={14}
                fill={DEFAULT_AREA_FILL_COLOR}
                fillOpacity={0.15}
                stroke={DEFAULT_AREA_FILL_COLOR}
                strokeOpacity={0.6}
                strokeWidth={2}
            />
        </svg>
    );
}

function withGeometryTypeFilter(filter: ExpressionSpecification | undefined, geometryType: string): ExpressionSpecification {
    const geometryFilter: ExpressionSpecification = ["==", ["geometry-type"], geometryType];
    return filter ? ["all", filter, geometryFilter] : geometryFilter;
}
